import { render } from "./BoqItemTable.vue?vue&type=template&id=bd1f19ac&scoped=true"
import script from "@/assets/boq/components/BoqItemTable.js?vue&type=script&lang=js"
export * from "@/assets/boq/components/BoqItemTable.js?vue&type=script&lang=js"

import "./BoqItemTable.vue?vue&type=style&index=0&id=bd1f19ac&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1f19ac"]])

export default __exports__